import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PolitiqueConfidentialite() {
  return (
    <main style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />

      <section className="bg-white pt-32 pb-8">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <span className="text-xs font-medium tracking-widest text-[#6B6B6B] uppercase">Légal</span>
          <h1 className="text-4xl lg:text-5xl font-bold text-[#0A0A0A] mt-3 leading-tight">
            Politique de confidentialité
          </h1>
          <div className="mt-4 w-16 h-0.5 bg-[#0A0A0A]" />
          <p className="mt-4 text-sm text-[#6B6B6B]">Dernière mise à jour : mars 2026</p>
        </div>
      </section>

      <article className="bg-white py-12 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 space-y-10">

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">1. Responsable du traitement</h2>
            <div className="bg-[#F7F6F4] rounded-lg p-6" style={{ fontFamily: 'monospace' }}>
              <p className="text-sm text-[#0A0A0A] font-semibold">HASPICA</p>
              <p className="text-sm text-[#6B6B6B]">Patrik Haspica — Entrepreneur individuel</p>
              <p className="text-sm text-[#6B6B6B]">SIRET : 102 262 441 00011</p>
              <p className="text-sm text-[#6B6B6B]">12 Rue Judaïque, 33000 Bordeaux, France</p>
              <p className="text-sm text-[#6B6B6B]">Email : patrikhasp1ca@outlook.com</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">2. Données collectées</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed mb-3">
              Ce site peut collecter les données suivantes via le formulaire de contact :
            </p>
            <ul className="list-none space-y-2">
              {['Nom et prénom', 'Adresse email', 'Numéro de téléphone', 'Description du projet / message'].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-[#6B6B6B]">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] text-[#6B6B6B]" />
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">3. Finalité du traitement</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Les données collectées sont utilisées <strong className="text-[#0A0A0A]">uniquement pour répondre aux demandes</strong> soumises via le formulaire de contact. Elles permettent à HASPICA d'entrer en relation avec les personnes ayant manifesté un intérêt pour ses services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">4. Conservation des données</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Les données sont conservées le temps nécessaire au traitement de la demande et à la relation commerciale qui peut en découler. Elles sont ensuite supprimées ou anonymisées conformément aux dispositions légales en vigueur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">5. Partage des données</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Les données collectées ne sont <strong className="text-[#0A0A0A]">ni vendues ni partagées avec des tiers</strong>. Elles restent strictement confidentielles et sont exclusivement utilisées par HASPICA dans le cadre de ses activités.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">6. Droits des personnes</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed mb-3">
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants :
            </p>
            <ul className="space-y-2">
              {[
                'Droit d\'accès à vos données',
                'Droit de rectification',
                'Droit à l\'effacement (« droit à l\'oubli »)',
                'Droit à la limitation du traitement',
                'Droit d\'opposition',
              ].map((right) => (
                <li key={right} className="flex items-center gap-2 text-sm text-[#6B6B6B]">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] text-[#6B6B6B]" />
                  </div>
                  {right}
                </li>
              ))}
            </ul>
            <p className="text-sm text-[#6B6B6B] leading-relaxed mt-4">
              Pour exercer ces droits, contactez-nous à :{' '}
              <a
                href="mailto:patrikhasp1ca@outlook.com"
                className="text-[#0A0A0A] underline cursor-pointer"
                rel="nofollow"
              >
                patrikhasp1ca@outlook.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">7. Cookies</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Ce site n'utilise pas de cookies de suivi ou de cookies publicitaires. Des cookies techniques strictement nécessaires au fonctionnement du site peuvent être utilisés.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">8. Contact</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Pour toute question relative à la présente politique de confidentialité, veuillez nous contacter à l'adresse suivante :{' '}
              <a
                href="mailto:patrikhasp1ca@outlook.com"
                className="text-[#0A0A0A] underline cursor-pointer"
                rel="nofollow"
              >
                patrikhasp1ca@outlook.com
              </a>
            </p>
          </section>

        </div>
      </article>

      <Footer />
    </main>
  );
}
